import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { EcoChallengeModel } from '../models/eco-challenge.model';

export class EcoChallengeInvoiceApiService extends ApiService {
  static endpoint = 'eco-challenge/{eco_challenge_id}/invoice/{invoice_id}';

  /**
   * @param {number | null} ecoChallengeId
   * @param {number | null} invoiceId
   * @returns {string}
   * @protected
   */
  static buildInvoiceUrl(ecoChallengeId, invoiceId) {
    return this.buildUrl().replace('{eco_challenge_id}', ecoChallengeId).replace('{invoice_id}', invoiceId);
  }

  /**
   * @param {string | number} ecoChallengeId
   * @param {string | number} invoiceId
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise<ApiResponse<EcoChallengeModel>>}
   * @public
   */
  static async get(ecoChallengeId, invoiceId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildInvoiceUrl(ecoChallengeId, invoiceId), {
      ...config,
      dataModel: EcoChallengeModel,
      useVApi: true,
      isBlob: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
